import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessCommunityFeed } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canListMessages } from "@/helpers/permissions";
import { canCreateMessage } from "@/modules/community-feed/permissions";

import { communityFeedRoutes } from "./routes";

export const communityFeedRoute = [
  {
    path: communityFeedRoutes.list,
    lazy: async () => {
      const { CommunityFeedPage } = await import("./pages/community-feed/CommunityFeedPage");

      return {
        element: (
          <RequireAuth permission={canAccessCommunityFeed}>
            <CommunityFeedPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: communityFeedRoutes.postDetails,
    lazy: async () => {
      const { MessageDetailPage } = await import("./pages/message-detail/MessageDetailPage");

      return {
        element: (
          <RequireAuth permission={canListMessages}>
            <MessageDetailPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: communityFeedRoutes.pollDetails,
    lazy: async () => {
      const { PollDetailsPage } = await import("./pages/poll-details/PollDetailsPage");

      return {
        element: (
          <RequireAuth permission={canListMessages}>
            <PollDetailsPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: communityFeedRoutes.adminCreatePost,
    lazy: async () => {
      const { AdminCreatePostPage } = await import("./pages/admin-create-post/AdminCreatePostPage");

      return {
        element: (
          <RequireAuth permission={canCreateMessage}>
            <AdminCreatePostPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
